import { FormattedMessage } from 'react-intl';
import type { Moment } from 'moment';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';

import Typography from '@mui/material/Typography';

import type { FilteredShift } from './utils';
import ShiftCell from './ShiftCell';
import messages from './messages';

type DayColumnProps = {
  dayDate: Moment;
  filteredShifts: FilteredShift[];
  maxShifts: number;
  highlightPublisherId: number | null;
};

const DayColumn = ({
  dayDate,
  filteredShifts,
  maxShifts,
  highlightPublisherId,
}: DayColumnProps) => {
  const rowSpan = 1 + maxShifts;

  return (
    <Box
      sx={{
        display: 'grid',
        gridRow: `span ${rowSpan}`,
        gridTemplateRows: 'subgrid',
        borderBottom: 1,
        borderRight: 1,
        borderColor: 'divider',
        pb: 2,
      }}
    >
      <Typography
        variant="overline"
        sx={{ fontWeight: 'bold', display: 'block', mb: 1, px: 2, pt: 1 }}
      >
        {dayDate.format('dddd, D. MMMM YYYY')}
      </Typography>
      {filteredShifts.length === 0 ? (
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            px: 2,
          }}
        >
          (<FormattedMessage {...messages.noShifts} />)
        </Typography>
      ) : (
        <>
          {filteredShifts.map(({ shift, turns }) => {
            return (
              <Card
                key={shift.id}
                elevation={0}
                sx={{
                  borderRadius: 0,
                }}
              >
                <ShiftCell
                  shift={shift}
                  turns={turns}
                  highlightPublisherId={highlightPublisherId}
                />
              </Card>
            );
          })}
        </>
      )}
    </Box>
  );
};

export default DayColumn;
